




























































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import { BPagination } from 'bootstrap-vue';

const ALL = 0;

@Component({
  components: {
    BPagination,
  },
})
export default class PaginationComponent extends Vue {
  @Prop({
    type: Number,
    required: true,
  })
  public totalResults!: number;

  @Prop({
    type: Number,
    required: true,
  })
  public numberOfPages!: number;

  @Prop({
    type: Number,
    default: 12,
  })
  public itemsPerPage!: number;

  @Prop({
    type: Number,
    required: true,
    default: 1,
  })
  public currentPage!: number;

  @Prop({
    type: Array,
    default: () => [3, 6, 12, ALL],
  })
  public itemsPerPageOptions!: number[];

  @Prop({
    type: String,
    default: 'GENERIC.ITEMS',
  })
  public itemsPluralKey!: string;

  @Prop({
    type: String,
    default: 'GENERIC.ITEM',
  })
  public itemsSingularKey!: string;

  @Prop({
    type: Boolean,
    default: true,
  })
  public showPaginationSummary!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  })
  public hideItemsPerPage!: boolean;

  public isAllSelected = false;

  get itemsPerPageLabel(): string {
    return this.itemsPerPage > 1
      ? `${this.$t(this.itemsPluralKey)} / ${this.$t('GENERIC.PAGE')}`
      : `${this.$t(this.itemsSingularKey)} / ${this.$t('GENERIC.PAGE')}`;
  }

  get itemsInTotalLabel(): string {
    return this.totalResults > 1
      ? `${this.$t(this.itemsPluralKey)} ${this.$t('PAGINATION.IN_TOTAL')}`
      : `${this.$t(this.itemsSingularKey)} ${this.$t('PAGINATION.IN_TOTAL')}`;
  }

  get itemsPerPageProxy(): number {
    return this.itemsPerPage || this.totalResults;
  }

  set itemsPerPageProxy(value: number) {
    this.changePage(1);
    this.$emit('update:items-per-page', value);
  }

  get canGoBack(): boolean {
    return this.currentPage > 1;
  }

  get canGoForward(): boolean {
    return this.currentPage < this.numberOfPages;
  }

  get currentPageSummary(): string {
    const currentItemsStart = (this.currentPage - 1) * this.itemsPerPageProxy + 1;
    const currentItemsEnd = currentItemsStart + this.itemsPerPageProxy - 1;
    const maxCurrentItemsEnd = currentItemsEnd > this.totalResults
      ? this.totalResults
      : currentItemsEnd;
    const itemsLabel = this.totalResults > 1
      ? this.$t(this.itemsPluralKey)
      : this.$t(this.itemsSingularKey);
    return `${this.$n(currentItemsStart)} - ${this.$n(maxCurrentItemsEnd)} ${this.$t('GENERIC.OF')} ${this.$n(this.totalResults)} ${itemsLabel}`;
  }

  public changePage(page: number): void {
    this.$emit('update:current-page', page);
  }

  @Watch('itemsPerPage')
  onChangeItemsPerPage(newValue: number) {
    this.isAllSelected = !newValue;
  }
}
